import { APIConnectionFirmsAgGrid } from './APIConnectionFirms';

export interface IAPIFirmsAgGridProps{
    apiConnectionID: string;
}

export default APIConnectionFirmsAgGrid;